import { BottomSheetBackdrop, BottomSheetModal, BottomSheetModalProvider, BottomSheetView } from '@gorhom/bottom-sheet';
import { Layout, Text, useTheme } from '@ui-kitten/components';
import React, { PropsWithChildren, RefObject, useMemo } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/lib/typescript/types';
import DownwardIcon from './DownwardIcon';

const styles = StyleSheet.create({
  container: {
    borderTopWidth: 10
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 10,
    paddingBottom: 10
  },
  body: {
    padding: 10,
    display: 'flex',
    gap: 15
  },
  saveBtn: {
    marginTop: 5
  },
  contentContainerStyle: {
    paddingBottom: 20
  }
});

export interface ActionBottomSheetProps {
  sheetRef: RefObject<BottomSheetModalMethods>;
  title: string;
}

const ActionBottomSheet = ({ sheetRef, children, title }: PropsWithChildren<ActionBottomSheetProps>) => {
  // Define static snap points
  const snapPoints = useMemo(() => ['50%', '80%'], []);

  const th = useTheme();

  const handleClose = () => {
    sheetRef.current?.dismiss();
  };

  return (
    <BottomSheetModalProvider>
      <BottomSheetModal
        ref={sheetRef}
        snapPoints={snapPoints} // Static snap points
        index={0}
        enablePanDownToClose={false}
        backdropComponent={(backdropProps) => (
          <BottomSheetBackdrop {...backdropProps} enableTouchThrough={false} appearsOnIndex={1} />
        )}
        handleIndicatorStyle={{ height: 0 }}
        backgroundStyle={{ backgroundColor: th['background-basic-color-1'] }}>
        <BottomSheetView>
          <Layout level="1" style={styles.contentContainerStyle}>
            <View style={styles.header}>
              <View style={{ width: 24 }} />
              <Text category="h6">{title}</Text>
              <TouchableOpacity onPress={handleClose}>
                <DownwardIcon size={24} color={th['text-basic-color']} />
              </TouchableOpacity>
            </View>
            <View style={{ height: 1, marginVertical: 5, backgroundColor: th['text-basic-color'] }} />
            <View style={styles.body}>{children}</View>
          </Layout>
        </BottomSheetView>
      </BottomSheetModal>
    </BottomSheetModalProvider>
  );
};

export default ActionBottomSheet;
